import { URL_TYPES } from 'common/constants';
import { downloadFileFromName as downloadWiseFile } from 'common/modules/lisaFiles/actions';
import { downloadFileFromName as downloadZapFile } from 'common/modules/zap/actions';
import { handleDownloadSunwiseFile } from 'common/utils/helpers';

import { resolveUrlType } from '../helpers';

export default ({ name, uploadOrigin, url, urlType } = {}) =>
    (dispatch) => {
        if (!url) return;

        const resolvedUrlType = resolveUrlType(uploadOrigin, urlType);

        switch (resolvedUrlType) {
            case URL_TYPES.WISE:
                dispatch(downloadWiseFile(url));
                break;
            case URL_TYPES.ZAP:
                dispatch(downloadZapFile(url));
                break;
            default:
                handleDownloadSunwiseFile(url, name);
        }
    };
